<template>
  <div class="p-a01-message-list-panel">
    <div class="p-a01-message-list-panel__main">
      <div class="p-a01-message-list-panel__meta">
        <div class="p-a01-message-list-panel__users">
          <span class="p-a01-message-list-panel__name" data-translate-skip>{{
            message.fromUserName
          }}</span>
          <IconBase
            class="p-a01-message-list-panel__arrow"
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            icon-color="#0d76bf"
          >
            <IconArrowRight />
          </IconBase>
          <span class="p-a01-message-list-panel__name" data-translate-skip>{{
            message.toUserName
          }}</span>
        </div>
        <div class="p-a01-message-list-panel__point" data-translate-skip>
          <span
            class="p-a01-message-list-panel__point-value"
            >{{ addComma(message.points) }}</span
          >
          <span class="p-a01-message-list-panel__point-unit">{{ unit }}</span>
        </div>
      </div>
      <div class="p-a01-message-list-panel__content">
        <div class="p-a01-message-list-panel__bubble-wrap">
          <div class="p-a01-message-list-panel__bubble">
            <p class="p-a01-message-list-panel__message" data-translate-skip>
              {{ message.message }}
            </p>
          </div>
        </div>
        <p class="p-a01-message-list-panel__created_at">{{ date }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { addComma as addCommaFilter } from "@/common/assets/js/filters";
import { Options, Vue } from "vue-class-component";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    message: { type: Object, required: true }
  },
  components: {
    IconBase,
    IconArrowRight
  }
})
export default class A01MessageListPanel extends Vue {
  message!: any;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }

  get date() {
    return this.$dayjs
      .utc(this.message.date)
      .locale("ja")
      .format("YYYY/MM/DD HH:mm");
  }

  addComma = addCommaFilter;
}
</script>

<style lang="scss" scoped>
.p-a01-message-list-panel {
  display: flex;
  flex-shrink: 0;
  width: 100%;
  min-width: 0;

  &__main {
    display: flex;
    gap: rem(16);
    align-items: flex-start;
    width: 100%;
    min-width: 0;
  }

  &__content {
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    gap: rem(8);
    min-width: 0;

    @include large-sp {
      gap: rem(4);
    }
  }

  &__meta {
    display: flex;
    flex: 0 1 auto;
    flex-direction: column;
    align-items: center;
    min-width: rem(80);
    padding: rem(4) 0 0;
  }

  &__users {
    display: flex;
    flex-wrap: nowrap;
    gap: rem(4);
    align-items: center;
    justify-content: center;
  }

  &__name {
    flex: 0 0 auto;
    width: rem(110);
    max-width: rem(110);
    overflow: hidden;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(14);
    font-weight: 700;
    line-height: 1.25;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-feature-settings: "pwid" 1, "palt" 1;

    @include sp {
      font-size: rem(12);
    }
  }

  &__arrow {
    flex-shrink: 0;
  }

  &__point {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
  }

  &__point-value {
    overflow: hidden;
    color: #da291c;
    font-family: $font--noto-sans-only;
    font-size: rem(14);
    text-overflow: ellipsis;
    font-feature-settings: "palt" 1, "pwid" 1;

    @include sp {
      font-size: rem(12);
    }
  }

  &__point-unit {
    flex-shrink: 0;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(10);
    font-feature-settings: "palt" 1, "pwid" 1;

    @include sp {
      font-size: rem(8);
    }
  }

  &__bubble-wrap {
    display: flex;
    align-items: flex-start;
    width: 100%;
    min-width: 0;
    padding-left: rem(8);
  }

  &__bubble {
    position: relative;
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
    padding: rem(8) rem(16);
    background-color: $common-white;
    border-radius: rem(4);

    &::before {
      position: absolute;
      top: rem(12);
      left: 0;
      width: 0;
      height: 0;
      border-color: transparent $common-white transparent transparent;
      border-style: solid;
      border-width: rem(8) rem(8) rem(8) 0;
      transform: translateX(-100%);
      content: "";
    }
  }

  &__message {
    width: 100%;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(16);
    font-weight: 400;
    line-height: 1.5;
    overflow-wrap: break-word;
    font-feature-settings: "palt" 1, "pwid" 1;

    @include large-sp {
      font-size: rem(14);
    }

    @include sp {
      font-size: rem(12);
    }
  }

  &__created_at {
    align-self: flex-end;
    color: #003459;
    font-family: $font--noto-sans-only;
    font-size: rem(12);
    font-weight: 400;
    line-height: 1;
    white-space: nowrap;
    font-feature-settings: "palt" 1, "pwid" 1;

    @include sp {
      font-size: rem(10);
    }
  }

  @include large-sp {
    .p-a01-message-list-panel__users {
      flex-direction: column;
      flex-wrap: nowrap;
      gap: 0;
    }

    .p-a01-message-list-panel__arrow {
      margin-top: rem(-3);
      margin-bottom: rem(-5);
      transform: rotate(90deg);
    }

    .p-a01-message-list-panel__point-value {
      min-width: 0;
    }
  }
}
</style>
